import { Typography } from '@material-ui/core'
import Stack from '@mui/material/Stack'
import { useTranslate } from 'react-admin'
import Alert from '@mui/material/Alert'
import moment from 'moment'
import { Button } from '@mui/material'

const OpposantsHeader = (props) => {
  const { informations } = props
  const translate = useTranslate()
  return (
    <Stack sx={{ width: '100%' }} spacing={2} marginBottom={'15px'}>
      <Typography variant="h6">{translate('hs.ags.opponents')}</Typography>
      {informations && !informations.pv_signed && (
        <Alert severity="warning">
          Le PV n’est pas encore signé par tous les signataires.
        </Alert>
      )}
      {informations && informations?.trigger_at && informations.pv_signed && (
        <Alert
          severity="success"
          style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <div style={{ marginRight: '10px' }}>
              Déclenché le {moment(informations?.trigger_at).format('LL')} par{' '}
              {informations?.trigger_by}
              {informations?.subscription_url && (
                <span style={{ fontWeight: 'bold' }}>
                  {' '}
                  - ID Athome de suivi:{' '}
                  {informations.subscription_url.split('/').pop()}
                </span>
              )}
            </div>

            {informations?.subscription_url && (
              <Button
                component="a"
                href={informations?.subscription_url}
                target="_blank"
                rel="noopener noreferrer"
                color="primary"
                variant="contained"
                size="large"
              >
                Suivre les envois
              </Button>
            )}
          </div>
        </Alert>
      )}
    </Stack>
  )
}

export default OpposantsHeader
